// eslint-disable-next-line @typescript-eslint/no-explicit-any
export type Anything = any;

export enum Color {
	Izibizi = '#541753',
	IzibiziOpacity = '#875D87',
}

export interface Contact {
	phone: string;
}
